import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      subtitle="Gemäss dem Schweizer Datenschutzgesetz (DSG / revDSG) informieren wir Sie über die Bearbeitung Ihrer Personendaten."
    >
      <LegalSection heading="1. Verantwortliche Stelle">
        <p>
          Verantwortlich für die Bearbeitung Ihrer Personendaten ist:
          <br />
          <strong>Urban Beauty Klosters</strong>, Alexandra Urban, Landstrasse 206,
          7250 Klosters, Schweiz. E-Mail: urban_ale_2007@yahoo.com.
        </p>
      </LegalSection>

      <LegalSection heading="2. Grundsätze">
        <p>
          Wir bearbeiten Personendaten im Einklang mit dem Schweizer
          Datenschutzgesetz (DSG) sowie – soweit anwendbar – der europäischen
          Datenschutz-Grundverordnung (DSGVO). Wir erheben und bearbeiten nur
          diejenigen Daten, die für die Bereitstellung unserer Dienstleistungen
          und den Betrieb dieser Website erforderlich sind.
        </p>
      </LegalSection>

      <LegalSection heading="3. Terminbuchung über Fresha">
        <p>
          Für die Online-Terminbuchung nutzen wir die Plattform Fresha
          (Fresha Inc.). Wenn Sie auf «Termin buchen» klicken, werden Sie auf
          das Buchungsportal von Fresha weitergeleitet. Die dort von Ihnen
          eingegebenen Daten (z. B. Name, E-Mail-Adresse, Telefonnummer,
          gewünschte Behandlung, Datum und Uhrzeit) werden durch Fresha als
          eigenständigen Anbieter bearbeitet. Es gelten zusätzlich die
          Datenschutzbestimmungen von Fresha. Wir verwenden diese Daten
          ausschliesslich zur Bearbeitung und Bestätigung Ihres Termins.
        </p>
      </LegalSection>

      <LegalSection heading="4. Kontaktaufnahme via WhatsApp">
        <p>
          Über das Kontaktformular sowie den WhatsApp-Button können Sie uns per
          WhatsApp (WhatsApp Ireland Ltd. / Meta Platforms) kontaktieren. Beim
          Absenden wird die WhatsApp-Anwendung geöffnet und die von Ihnen
          eingegebenen Angaben werden als Nachricht übermittelt. Dabei können
          Daten an Meta – auch in Länder ausserhalb der Schweiz bzw. der EU
          (z. B. USA) – übertragen werden. Es gelten ergänzend die
          Datenschutzbestimmungen von WhatsApp/Meta. Die Nutzung von WhatsApp
          ist freiwillig; alternativ erreichen Sie uns telefonisch oder per
          E-Mail.
        </p>
      </LegalSection>

      <LegalSection heading="5. Eingebettete Karte (Google Maps)">
        <p>
          Auf unserer Website binden wir eine Karte des Dienstes Google Maps
          (Google Ireland Ltd.) ein. Die Karte wird erst nach Ihrer
          ausdrücklichen Einwilligung («Karte anzeigen» bzw. Cookie-Zustimmung)
          geladen. Beim Laden können Daten wie Ihre IP-Adresse an Google – auch
          in die USA – übertragen werden. Ohne Ihre Einwilligung werden keine
          Inhalte von Google Maps geladen. Es gelten ergänzend die
          Datenschutzbestimmungen von Google.
        </p>
      </LegalSection>

      <LegalSection heading="6. Cookies und lokale Speicherung">
        <p>
          Diese Website verwendet technisch notwendige Speichermechanismen
          (z. B. localStorage), um Ihre Cookie-Einwilligung zu speichern. Es
          werden keine Tracking- oder Marketing-Cookies eingesetzt, sofern Sie
          dem nicht ausdrücklich zustimmen. Externe Inhalte (z. B. Google Maps)
          werden erst nach Ihrer Einwilligung geladen. Sie können Ihre
          Einwilligung jederzeit über die Einstellungen Ihres Browsers
          widerrufen.
        </p>
      </LegalSection>

      <LegalSection heading="7. Server-Logfiles">
        <p>
          Beim Besuch unserer Website können automatisch Informationen
          (z. B. IP-Adresse, Browsertyp, Datum und Uhrzeit des Zugriffs) in
          sogenannten Server-Logfiles erfasst werden. Diese Daten dienen der
          Sicherheit und dem technischen Betrieb und lassen keine direkten
          Rückschlüsse auf Ihre Person zu.
        </p>
      </LegalSection>

      <LegalSection heading="8. Weitergabe an Dritte">
        <p>
          Ihre Personendaten werden nicht an Dritte verkauft. Eine Weitergabe
          erfolgt nur, soweit dies zur Erbringung unserer Dienstleistungen
          erforderlich ist (z. B. an die oben genannten Dienstleister Fresha,
          WhatsApp/Meta und Google) oder wir gesetzlich dazu verpflichtet sind.
        </p>
      </LegalSection>

      <LegalSection heading="9. Ihre Rechte">
        <p>
          Sie haben das Recht auf Auskunft über die von uns bearbeiteten
          Personendaten sowie auf Berichtigung, Löschung oder Einschränkung der
          Bearbeitung. Zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte
          unter urban_ale_2007@yahoo.com.
        </p>
      </LegalSection>

      <LegalSection heading="10. Datensicherheit">
        <p>
          Wir treffen angemessene technische und organisatorische Massnahmen,
          um Ihre Daten gegen Verlust, Missbrauch und unbefugten Zugriff zu
          schützen.
        </p>
      </LegalSection>

      <LegalSection>
        <p className="text-sm italic">
          Stand: Juni 2026. Wir behalten uns vor, diese Datenschutzerklärung
          jederzeit anzupassen.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
